module.exports = __webpack_public_path__ + "media/icons/marki-modele@2x-27ddf0f8.png";